module.exports = __webpack_public_path__ + "static/img/header_logo.d91ba06e.png";